import styled from 'styled-components';

interface TitleProps {
  isOtherProjectDetail?: boolean;
}
export const Title = styled.h2<TitleProps>`
  color: #333f48;
  font-size: 18px;
  font-weight: bold;
  line-height: normal;
  letter-spacing: normal;
`;
